import Vue from 'vue'
import App from './App.vue'

import store from './store'
import VueRouter from 'vue-router'
import VueMoment from 'vue-moment';
import moment from 'moment';

import Auth from './components/Auth.vue';
import Chat from './components/Chat.vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
moment.locale('pt-BR');

Vue.use(VueMoment, {
  moment
});

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

const routes = [
  { path: '/', component: Auth },
  { path: '/chat', component: Chat }

];
const router = new VueRouter({
  routes // short for `routes: routes`
})

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
